export default "__VITE_ASSET__CVLNy5qe__"